import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles, CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { sendJson } from '../../shared/utils/api'
import { usePromise } from '../../shared/utils/usePromise'
import { promiseError } from '../../shared/redux/actions/common'
import { useRouteMatch } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ValidationError from '../../shared/utils/validationError'

const useStyles = makeStyles((theme) => ({
    wrapper: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

const confirmAction = (token: string) => sendJson('users/confirm', 'POST', token)

const ConfirmAccount = () => {
    const { t } = useTranslation()
    const classes = useStyles()
    const history = useHistory()

    const dispatch = useDispatch()

    const confirmAccountRouteMatch = useRouteMatch(`/confirm-account/:token`)

    const routeToken: string = (confirmAccountRouteMatch?.params as any)?.token

    const [confirmPasswordStart, inProgress, result, error] = usePromise(confirmAction)

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const isIOS = () => {
        return (
            /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ||
            (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        );
    };

    useEffect(() => {
        if (routeToken) {
            confirmPasswordStart(routeToken);
        }
    }, [routeToken, confirmPasswordStart]);

    useEffect(() => {
        if (error instanceof ValidationError) {
            dispatch(promiseError(t('login.accountConfirmationValidationError', { error })))
        } else if (error) {
            dispatch(promiseError(t('login.accountConfirmationError', { error })))
        }
    }, [dispatch, t, error])

    useEffect(() => {
        if (result && !isMobile) {
            // Iba na PC presmerujeme hneď
            history.push('/login?confirmationSuccess');
        }
        // Na mobile nerobíme nič, result je true, takže sa v return zobrazia tlačidlá
    }, [result, isMobile, history]);

    const handleOpenApp = () => {
        const storeUrl = isIOS()
            ? "https://apps.apple.com/sk/app/charge-sk/id6745960330"
            : "https://play.google.com/store/apps/details?id=eu.starbug.charge.sk";

        if (isIOS()) {
            window.location.href = `charge://login-page`;
            setTimeout(() => {
                if (document.visibilityState === 'visible') {
                    window.location.href = storeUrl;
                }
            }, 1500);
            return;
        }

        // Android
        const intentUrl = `intent://login-page#Intent;scheme=chargesk;package=eu.starbug.charge.sk;S.browser_fallback_url=${encodeURIComponent(storeUrl)};end`;
        window.location.href = intentUrl;
    };

    const handleContinueOnWeb = () => {
        history.push('/login?confirmationSuccess')
    };

    return (
        <div className={classes.wrapper}>
            {inProgress && <CircularProgress />}

            {/* Ak je úspešne overené a sme na mobile, ukážeme možnosti */}
            {!inProgress && result && isMobile && (
                <div style={{ textAlign: 'center', padding: '20px', color: 'white' }}>
                    <h2 style={{ color: '#37c0ca', marginBottom: '10px' }}>
                        {t('login.confirmationSuccessTitle')}
                    </h2>
                    <p style={{ marginBottom: '30px', fontSize: '16px' }}>
                        {t('login.confirmationSuccessNote')}
                    </p>

                    <button
                        onClick={handleOpenApp}
                        style={{
                            background: '#37c0ca',
                            color: 'black',
                            padding: '14px 24px',
                            borderRadius: '25px',
                            border: 'none',
                            fontWeight: 'bold',
                            width: '100%',
                            marginBottom: '20px'
                        }}
                    >
                        {t('login.openInAppAndLogin')}
                    </button>

                    <button
                        onClick={handleContinueOnWeb}
                        style={{
                            background: 'transparent',
                            color: '#37c0ca',
                            border: 'none',
                            textDecoration: 'underline'
                        }}
                    >
                        {t('login.continueToWebLogin')}
                    </button>
                </div>
            )}
        </div>
    );
}

export default ConfirmAccount
